import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CalendarTimeIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3891 3C14.7714 3 15.0814 3.30996 15.0814 3.69231V6.32194C15.0814 6.70429 14.7714 7.01425 14.3891 7.01425C14.0067 7.01425 13.6968 6.70429 13.6968 6.32194V3.69231C13.6968 3.30996 14.0067 3 14.3891 3Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.93401 3C8.31636 3 8.62631 3.30996 8.62631 3.69231V6.32194C8.62631 6.70429 8.31636 7.01425 7.93401 7.01425C7.55166 7.01425 7.2417 6.70429 7.2417 6.32194V3.69231C7.2417 3.30996 7.55166 3 7.93401 3Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51493 5.4056C5.33698 4.62398 6.47975 4.26123 7.77777 4.26123H14.5431C15.8438 4.26123 16.9872 4.6237 17.8081 5.40621C18.6341 6.19363 19.0436 7.32054 19.0398 8.66445V10.9654C19.0398 11.3478 18.7299 11.6577 18.3475 11.6577C17.9652 11.6577 17.6552 11.3478 17.6552 10.9654V8.66359V8.66152C17.6583 7.60264 17.3421 6.87497 16.8527 6.40843C16.3579 5.93673 15.5955 5.64585 14.5431 5.64585H7.77777C6.72904 5.64585 5.96603 5.93647 5.46901 6.40904C4.97732 6.87655 4.65854 7.60511 4.65854 8.66359V15.8933C4.65854 16.9739 4.97944 17.7214 5.47388 18.2008C5.97173 18.6835 6.73324 18.9793 7.77777 18.9793H9.48413C9.86647 18.9793 10.1764 19.2893 10.1764 19.6716C10.1764 20.054 9.86647 20.3639 9.48413 20.3639H7.77777C6.47555 20.3639 5.3313 19.9911 4.51006 19.1948C3.68542 18.3954 3.27393 17.2537 3.27393 15.8933V8.66359C3.27393 7.31875 3.68754 6.19229 4.51493 5.4056Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6621 13.7918C14.0543 13.7918 12.7503 15.0958 12.7503 16.7036C12.7503 18.3114 14.0543 19.6154 15.6621 19.6154C17.2699 19.6154 18.5738 18.3114 18.5738 16.7036C18.5738 15.0958 17.2699 13.7918 15.6621 13.7918ZM11.3657 16.7036C11.3657 14.3311 13.2895 12.4072 15.6621 12.4072C18.0347 12.4072 19.9585 14.3311 19.9585 16.7036C19.9585 19.0762 18.0347 21 15.6621 21C13.2895 21 11.3657 19.0762 11.3657 16.7036Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.642 14.8018C16.0244 14.8018 16.3343 15.1116 16.3343 15.4941V16.5659L17.1368 17.0452C17.465 17.2413 17.5722 17.6663 17.3761 17.9946C17.18 18.3228 16.755 18.43 16.4267 18.2339L15.287 17.5532C15.0778 17.4282 14.9497 17.2025 14.9497 16.9588V15.4941C14.9497 15.1116 15.2597 14.8018 15.642 14.8018Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69434 9.8178C6.69434 9.43545 7.0043 9.12549 7.38664 9.12549H14.9289C15.3112 9.12549 15.6212 9.43545 15.6212 9.8178C15.6212 10.2002 15.3112 10.5101 14.9289 10.5101H7.38664C7.0043 10.5101 6.69434 10.2002 6.69434 9.8178Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default CalendarTimeIcon;
